<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row v-if="tstatus == false">
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('ItemCategory.LinkNewCategoryandItemtostore.List')" :contenttext="$t(
            'ItemCategory.LinkNewCategoryandItemtostore.TableHeaderContent'
          )
            ">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading" eheader="Item Store Mapping"
              econtent="Item Store Mapping" eimg="/src/assets/Img/icons/subgroupmaster.svg" @createNew="IsCreate" />
            <div class="">
              <Tableview v-if="items.length != 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                :exceldownload="true" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                selectionMode="single">
                <template v-slot:Add>
                  <span class="add">
                    <AddButton @click="IsCreate()" btnname="Add New" class="float-rights my-3"></AddButton>
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Item Store Mapping" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:ItemCount="{ data }">
                  <p @click="
                    navigatetopage('ItemMasterTableview', data.ItemCount, data)
                    ">
                    {{ data.ItemCount }}
                  </p>
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <!-- <EditIcon @click="Editdata(data)" class="me-3" />
                <DeleteIcon @click="Deletedata(data)" /> -->
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading" eheader="Item Store Mapping"
              econtent="Item Store Mapping" eimg="/src/assets/Img/icons/subgroupmaster.svg" @createNew="IsCreate" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="name">{{ item.StoreName }} </p>
                    </div>
                    <i class="pi pi-ellipsis-v " @click="toggle($event, item)"></i>
                  </div>
                  <p class="light-name">{{ item.CategoryName }} </p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Item Count :</p>
                    <p class="small-name">{{ item.ItemCount }}</p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
            <!-- <div class="d-flex justify-content-center">
                <b-pagination v-model="currentPage" :total-rows="mobilerows" :per-page="perPage" size="md"
                  aria-controls="my-table"></b-pagination>
              </div> -->
          </div>
        </div>
      </b-row>
    </b-container>
  </div>
  <!-- Commonly Used Components -->
  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete()" @no="Deletemodel = false" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <Toast />
  <!-- Commonly Used Components -->
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, watch, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import RowCreation from "../../../Masters/Stores/RowMaster/RowCreation.vue";
import { RouterLink, RouterView, useRoute, useRouter } from "vue-router";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from '../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue'
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    Tableview,
    BacktoPage,
    Headerlayout,
    RowCreation,
    MasterEmpty,
    Loader,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption
  },
  props: {
    tstatus: {
      default: false,
      type: Boolean,
    },

    storeid: {
      default: "",
      type: String,
    },
    propsParams: {
      type: Object,
    },
  },
  // props: {
  //   propsParams: {
  //     type: Object
  //   }
  // },

  setup(props) {
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem('UsersData')

    session = JSON.parse(session)
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId)
    // const ParamValues = ref({
    //   requestId: "",
    //   Id: 0,
    //   status: 0
    // });
    const toast = useToast();
    const routes = useRoute();
    // let StoreIddata = computed(() => {
    //   return routes.query.Id || 0;
    // });
    // ParamValues.value.Id = Number(StoreIddata);

    // watch(props, (newValue) => {
    //   debugger;
    //   ParamValues.value.Id = Number(props.propsParams)
    //   getbystoreID()
    // })
    let loading1 = ref(false);
    const menu = ref();
    //Loading
    let loading = ref(false);
    const router = useRouter();
    let dataId = routes.query.Id ?? 0;
    // let status = routes.query.status ?? 0;
    let columnnametype = routes.query.Type ?? "";
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      document.addEventListener("keydown", onKeyUp);
      window.addEventListener("resize", handleResize);
      if (dataId == 0) {
        IsShow();
      } else {
        getbystoreID();
      }
      FunctionRights();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(props, (newValue) => {
      debugger;
      // alert('s')
      let dataValue: any = {};
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        dataId = dataValue.Id;
        status = dataValue.Type;
        IsShow();
      }
    });
    const Editmodel = ref(false);
    const { t } = useI18n();

    let strid = 0;
    const deletepop = ref(false);
    const Deletemodel = ref(false);

    function Editdata(data) {
      debugger;
      strid = data.StoreId;
      Editmodel.value = true;
    }

    function Deletedata(data) {
      strid = data.StoreId;
      Deletemodel.value = true;
    }

    // filter for table
    const datas = ref();
    const items: any = ref([]);
    function toggle(event, data) {
      debugger;
      console.log(event);
      datas.value = data;
      // Id.value = event.Id
      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: true,
            command: async () => {
              // amendment();
              Editdata(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              // amendment();
              Deletedata(datas.value);
            },
          },
        ],
      },
    ]);

    //DataTable Fields

    const headers = [
      {
        header: "S.No",
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        header: "Store",
        field: "StoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: "Category",
        field: "CategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },

      {
        header: "Item Count",
        field: "ItemCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        bodyclass: "bluecolor",
        slot: "ItemCount",
        class: "smallwidth",
      },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: items },
      CategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ItemCount: { value: null, matchMode: FilterMatchMode.IN, options: items },
    };
    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await ItemStoreMappingService.storecatlist();
        console.log(response['result']);

        let count = 0;
        items.value = response["result"].filter((items) => items.HospitalId == HospitalId && items.BranchId == BranchId).map((item) => {
          count = count + 1
          item.RowNumber = count




          return item;
        });

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    //IsEdit Route

    function IsEdit() {
      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/ItemStoreMappingCreation",
          query: {
            Id: strid,
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const dataEdit = ref();
    const rowFocus = ref(false);

    // row click for table

    function RowClick(event: any) {
      debugger;
      // Editmodel.value = true;
      rowFocus.value = true;
      strid = event.data.StoreId;
    }

    //DataTable Array

    // let StoreId = computed(() => {
    //   return routes.query.StoreId || 0;
    // });

    // console.log(StoreIddata);

    let EntityData = localStorage.getItem("EntityData");
    let Entity;
    if (EntityData !== null) {
      Entity = JSON.parse(EntityData);
    }



    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(Entity.EntityId, rolesData.RoleId);
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    let IsShow = async () => {
      loading.value = true;
      try {
        const response = await ItemStoreMappingService.storecatlist();
        console.log(response['result']);

        let count = 0;
        items.value = response["result"]
          .filter((items) => items.HospitalId == HospitalId)
          .map((item) => {
            count = count + 1
            item.RowNumber = count
            // item.UnitRate = item.UnitRate.toFixed(2),
            //   item.Rate = item.Rate.toFixed(2)
            // item.MRP = item.MRP.toFixed(2)
            return item;
          });
        loading.value = false;
        debugger;
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    };

    const getbystoreID = async () => {
      try {

        const response = await ItemStoreMappingService.getbystoreID(dataId);
        if (columnnametype == "StoreId") {
          items.value = response["result"].filter((items) => items.HospitalId == HospitalId && items.BranchId == BranchId);
        } else {
          items.value = response["result"].filter((items) => items.HospitalId == HospitalId && items.BranchId == BranchId);
        }

        debugger;
      } catch (error) {
        alert(error);
      }
    };

    function navigatetopage(pagename, datacount, datas) {
      // alert('ok')
      if (datacount != 0) {
        router.push({
          path: "/ItemStoreMappingCreation",
          query: {
            Id: datas.StoreId,
          },
        });
      } else {
        // alert('s')
      }
    }

    const IsDelete = async () => {
      // alert(strid);

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        loading.value = true;
        try {
          const response = await ItemStoreMappingService.deletedata(strid);
          let message = response["ErrorInfo"].ErrorCode;
          loading.value = false;
          if (message == null) {
            IsShow();
            Deletemodel.value = false;
            deletepop.value = true;
          }
        } catch (error) {
          loading.value = false;
          alert(error);
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    const IsCreate = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/ItemStoreMappingCreation",
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false
      ) {
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsCreate();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit();
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    return {
      navigatetopage,
      Deletemodel,
      deletepop,
      Editmodel,
      Editdata,
      IsCreate,
      IsShow,
      IsDelete,
      Deletedata,
      IsEdit,
      RowClick,
      loading1,
      headers,
      items,
      filters,
      globalFilterFields,
      filteredColumns,
      getbystoreID,
      loading,
      menu,
      toggle,
      itemListed,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>